import { render, staticRenderFns } from "./expand-sub-campaign.vue?vue&type=template&id=096c5665&functional=true"
import script from "./expand-sub-campaign.vue?vue&type=script&lang=js"
export * from "./expand-sub-campaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports